module.exports = {"see-more":"Lire +","see-less":"Fermer"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = 90
// module chunks = 0